import { post, get, postFd, del, getBlob } from "@utils/axios";

const api = "user-case-management";

// export const getUserCasesReq = (type) => {
//   return get(`${api}/get-cases/` + type);
// }

export const getUserCasesReq = (payload) => {
  // payload: { type, page, limit, search, overdue }
  const { type = 'total', page = 1, limit = 10, search = '', overdue = false } = payload || {};
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
  // Admin-only, and enforced as such on the server — a doctor sending it
  // by hand gets the unfiltered list back.
  const overdueParam = overdue ? '&overdue=1' : '';
  return get(`${api}/get-cases/${type}?page=${page}&limit=${limit}${searchParam}${overdueParam}`);
};


/**
 * The case's files, as a zip.
 *
 * This used to return a URL to a zip the server had written into its
 * public directory, where it stayed forever and anyone who guessed the
 * name could read it. The zip is built and streamed now, so what comes
 * back is the file itself.
 */
export const getDownloadFilesReq = (id) => {
  return getBlob(`${api}/download-files/` + id);
}

export const getUserCaseDetailReq = (id) => {
  return get(`${api}/get-case-detail/${id}`);
}

export const getUserCaseChatReq = (id) => {
  return get(`${api}/get-case-discussion/${id}`);
}
export const getUserCaseTreatementReq = (id) => {
  return get(`${api}/get-user-case-treatment/${id}`);
}

export const addUserCaseChatReq = (payload) => {
  return post(`${api}/add-user-case-discussion`, payload);
}

export const getUserCasesIdReq = () => {
  return get(`${api}/get-case-ids`);
}

export const takeUserCasReq = (id) => {
  return get(`${api}/take-user-case/` + id);
}

export const abendUserCasReq = (payload) => {
  // payload: { id, reason }
  return post(`${api}/abend-user-case`, payload);
}

export const saveUserCasTreatmentPlanDataReq = (payload) => {
  return post(`${api}/add-user-case-treatment/`, payload);
}
export const updateUserCasTreatmentPlanDataReq = (payload) => {
  return post(`${api}/update-user-case-treatment/`, payload);
}

export const saveStclFileReq = (payload) => {
  return post(`${api}/submit-stlc`, payload);
}

export const acceptCaseReq = (id) => {
  return get(`${api}/accept-case/` + id);
}

export const rejectCaseReq = (payload) => {
  return post(`${api}/reject-case`, payload);
}

export const cancelCaseReq = (payload) => {
  return post(`${api}/cancel-case`, payload);
}

export const completeCaseReq = (id) => {
  return get(`${api}/complete-case/` + id);
}

export const resolveMissingDataReq = (id) => {
  return get(`${api}/resolve-missing-data/` + id);
}

export const getCaseContainersReq = (id) => {
  return get(`${api}/get-case-containers/` + id);
}

export const addCaseContainerReq = (payload) => {
  // payload: FormData { case_id, file }
  return postFd(`${api}/add-case-container`, payload);
}

export const deleteCaseContainerReq = (id) => {
  return del(`${api}/delete-case-container/` + id);
}